import { render, staticRenderFns } from "./expandable-route-list.vue?vue&type=template&id=16462183&"
import script from "./expandable-route-list.vue?vue&type=script&lang=js&"
export * from "./expandable-route-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports